/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';
import DataContainer from 'Util/Request/DataContainer';
import StorePage from './StorePage.component';
import PropTypes from 'prop-types';
import { updateMeta } from 'Store/Meta/Meta.action';
import {StorePageDispatcher} from "../../store/StorePage";
import {StoreLocatorDispatcher} from "../../store/StoreLocator";
export const BreadcrumbsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Breadcrumbs/Breadcrumbs.dispatcher'
    );

/** @namespace Route/StorePage/Container/mapStateToProps */
export const mapStateToProps = state => ({
    storePageData : state.StorePage.storePageData,
    storeLocatorData : state.StoreLocatorReducer.storeLocatorData,
    store_locator_url : state.ConfigReducer.store_locator_url,
    google_map_api_key : state.ConfigReducer.google_map_api_key,
    map_markericon : state.ConfigReducer.map_markericon,
    map_selected_markericon : state.ConfigReducer.map_selected_markericon,
    device: state.ConfigReducer.device
});

/** @namespace Route/StorePage/Container/mapDispatchToProps */
export const mapDispatchToProps = dispatch => ({
    updateBreadcrumbs: (breadcrumbs) => {
        BreadcrumbsDispatcher.then(
            ({ default: dispatcher }) => dispatcher.update(breadcrumbs, dispatch)
        );
    },
    getStorePageData : store_id => StorePageDispatcher.handleData(dispatch,store_id),
    getStoreLocatorData : () => StoreLocatorDispatcher.handleData(dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta))
});

/** @namespace Route/StorePage/Container */
export class StorePageContainer extends DataContainer {
    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        updateMeta: PropTypes.func.isRequired,
        store_id: PropTypes.number,
    };

    static defaultProps = {
        storeLocatorData: {}
    };

    state = {
        activeTab : 1,
        store : {},
        currentCategory : {}
    }

    static getDerivedStateFromProps(props,state) {
        const { storePageData : { item }, store_id } = props;
        if(item && item[0] && (!Object.keys(state.store).length || store_id != state.store.store_id)){
            return {
                store : item[0]
            }
        }
        return null;
    }

    constainerProps(){
        const { currentCategory, store, activeTab } = this.state;
        const { store_id, storePageData, device, map_selected_markericon, map_markericon } = this.props;
        return {
            currentCategory,
            store,
            activeTab,
            storePageData,
            store_id,
            map_markericon,
            map_selected_markericon,
            device
        }
    }

    componentDidMount() {
        const {
            updateMeta,
            title,
            meta_title,
            storeLocatorData,
            getStoreLocatorData,
            meta_keywords,
            meta_description,
            store_id,
            getStorePageData,
            redirect_code_previous
        } = this.props;

        getStorePageData(store_id);

        if (storeLocatorData.constructor === Object) {
            getStoreLocatorData();
        }

        updateMeta({
            title: meta_title || title,
            description: meta_description,
            keywords: meta_keywords,
            canonical_url : window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous

        });
        this._updateBreadcrumbs();
        scroll({
            top: 0,
            behavior: "smooth"
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentCategory, store } = this.state;
        const { store_id, storeLocatorData, storeLocatorData: { items }, storePageData } = this.props;
        const { store_id: prevStoreId, storeLocatorData: { items: prevItems } } = prevProps;
        if (storeLocatorData.items && ((store_id != prevStoreId) || Object.keys(currentCategory).length === 0 || JSON.stringify(items) !== JSON.stringify(prevItems))) {
            Object.values(storeLocatorData.items).map(item => {
                if(store.category_id == item.category_id){
                    this.setState({ currentCategory : item });
                }
            });
        }
    }

    _updateBreadcrumbs() {
        const { updateBreadcrumbs,  store_locator_url, title } = this.props;
        const breadcrumbs = [
            {
                url: `${window.location.pathname}`,
                name: title
            },
            {
                url: `/${store_locator_url}`,
                name: __('Store Locator')
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    containerFunctions = {
        setActiveTab : this.setActiveTab.bind(this)
    }

    setActiveTab(index){
        this.setState({
            activeTab : index
        });
    }

    render() {
        return (
            <StorePage
              { ...this.constainerProps() }
              { ...this.state }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StorePageContainer);
